module.exports = __webpack_public_path__ + "4_Messaging_withoutNavHeader-1522ccc0fbe3755d0be989548a437be5.png";